Pixlee.module('UploaderV3App.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            if (!App.hasTOS) {
                // We can't open the uploader if there is no TOS
                // Close it right away.
                // We are doing this here, since we can't block the uploader from being opened in the first place:
                // The decision to open the uploader is made in pixlee_widget.1.0.1.js (https://github.com/pixlee/photos/blob/c9ad0e38caa5701ffb90ba338f77a79c5569329b/public/javascripts/embed/widget/pixlee_widget.1.0.1.js#L311)
                // and we don't have access to display options or App.hasTOS there.
                window.parent.postMessage(JSON.stringify({
                    name: 'pixlee:close:uploader',
                    type: 'action',
                    source: 'uploader',
                    destination: 'parent',
                    data: {}
                }), '*');
                return;
            }
            var _this = this;
            var collectionView, headerView;
            this.initKeenData();
            // Needed because desktop submissions executes onShow by the number of photos in the collection
            this.keenUploadMediaDebounce = _.debounce(function(keenData) {
                _this.keenUploadMedia(keenData);
            }, 600, false);
            // Initialize all uploader collections needed
            this.initUploaderCollections();
            // Social Accounts
            Show.connectedUser = new App.Entities.Model();
            this.source = '';

            // Get two main views
            this.layout = this.getLayout({
                currentAlbum: options.current_album
            });
            this.homeView = this.getHomeView();
            // Set two views events
            this.setHomeViewEvents(this.homeView);
            this.setLayoutEvents(this.layout, this.homeView);
            // Show two main views
            this.showLayout(this.layout);
            this.showHomeView(this.homeView);
            // Preview Mode
            if (!_.isFalsy(gon.previewMode)) {
                this.setPreviewMode();
            }
        },
        setLayoutEvents: function(layoutView) {
            this.listenTo(layoutView, 'show:home:view', function() {
                this.initUploaderCollections();
                this.initKeenData();
                layoutView.mainContent.destroy(this.homeView);
                this.homeView = this.getHomeView();
                this.setHomeViewEvents(this.homeView);
                this.showHomeView(this.homeView);
            });
            this.listenTo(layoutView, 'check:pick:source', function() {
                if (this.uploaderCollection.length > 0) {
                    this.layout.onShowUploaderBackAlert();
                } else {
                    this.layout.trigger('show:home:view');
                }
            });
            this.listenTo(layoutView, 'check:select:content', function() {
                if (this.source === 'desktop' && this.uploaderCollection.length > 0) {
                    this.layout.onShowUploaderBackAlert('two');
                } else {
                    this.layout.trigger('show:select:content');
                }
            });
            this.listenTo(layoutView, 'show:select:content', function() {
                if (!this.uploaderCollection.length) {
                    this.keenUploadedMedia = false;
                }
                switch (this.source) {
                    case 'desktop':
                        this.homeView.trigger('show:desktop:drag:drop');
                        break;
                    case 'instagram':
                        this.homeView.trigger('show:instagram', this.instagramLogin);
                        break;
                    case 'facebook':
                        this.homeView.trigger('show:facebook', this.facebookLogin);
                        break;
                    case 'google':
                        this.homeView.trigger('show:gphotos', this.googleLogin);
                        break;
                    default:
                        break;
                }
            });
            this.listenTo(layoutView, 'show:review:submission', function() {
                this.initReviewPanel(this.source);
            });
            this.listenTo(layoutView, 'show:submit:content', function() {
                this.showFormView(this.formView);
            });
            this.listenTo(layoutView, 'keen:opened:uploader', function() {
                App.execute('click:uploader', 'Opened uploader', this.keenData);
            });
            this.listenTo(layoutView, 'keen:clicked:navigation', function(navTo, navFromNumber) {
                var keenNavData = _.extend({
                    nav_to: navTo,
                    nav_from: this.keenMapStep(navFromNumber)
                }, this.keenData);
                App.execute('click:uploader', 'Clicked navigation', keenNavData);
            });
            this.listenTo(layoutView, 'keen:canceled:submission', function(currentStepNumber) {
                this.keenData.nav_from = this.keenMapStep(currentStepNumber);
                App.execute('click:uploader', 'Canceled submission', this.keenData);
            });
        },
        setInfoPanelEvents: function(infoPanel) {
            this.listenTo(infoPanel, {
                'get:focus:index': this.getFocusIndex.bind(this)
            });
        },
        setHomeViewEvents: function(homeView) {
            this.listenTo(homeView, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:info': function() {
                    this.infoPanel = this.getInfoView();
                    this.setInfoPanelEvents(this.infoPanel);
                    this.showInfoPanel(this.infoPanel);
                },
                'show:desktop:drag:drop': function() {
                    this.source = 'desktop';
                    this.uploaderCollection = new App.Entities.Collection();
                    this.keenUploadedMedia = false;
                    this.dragDropView = this.getDragDropView({
                        collection: this.uploaderCollection,
                        connectedUser: Show.connectedUser
                    });
                    this.setDragDropEvents(this.dragDropView);
                    this.showDragDropView(this.dragDropView);
                    // Keen Tracking
                    if (!this.keenSelectedChannel) {
                        this.initKeenData();
                        this.keenData.channel = 'desktop';
                        App.execute('click:uploader', 'Selected channel', this.keenData);
                        this.keenSelectedChannel = true;
                    }
                },
                'show:instagram': function(socialLogin) {
                    this.source = 'instagram';
                    this.instagramLogin = socialLogin;
                    Show.connectedUser.set({
                        'instagram_token': socialLogin.access_token,
                        'instagram_avatar': socialLogin.avatar_url,
                        'instagram_email_address': socialLogin.email_address,
                        'instagram_user_name': socialLogin.user_name,
                        'instagram_id': socialLogin.social_id
                    });
                    this.initInstagramSocialPhotoPanel();
                    // Keen Tracking
                    if (!this.keenSelectedChannel) {
                        this.initKeenData();
                        this.keenData.channel = 'instagram';
                        App.execute('click:uploader', 'Selected channel', this.keenData);
                        this.keenSelectedChannel = true;
                    }
                },
                'show:facebook': function(socialLogin) {
                    this.source = 'facebook';
                    this.facebookLogin = socialLogin;
                    Show.connectedUser.set({
                        'facebook_token': socialLogin.access_token,
                        'facebook_avatar': socialLogin.avatar_url,
                        'facebook_email_address': socialLogin.email_address,
                        'facebook_user_name': socialLogin.user_name,
                        'facebook_id': socialLogin.social_id
                    });
                    this.initFacebookSocialPhotoAlbumsPanel();
                    // Keen Tracking
                    if (!this.keenSelectedChannel) {
                        this.initKeenData();
                        this.keenData.channel = 'facebook';
                        App.execute('click:uploader', 'Selected channel', this.keenData);
                        this.keenSelectedChannel = true;
                    }
                },
                'show:gphotos': function(socialLogin) {
                    this.source = 'google';
                    this.googleLogin = socialLogin;
                    Show.connectedUser.set({
                        'google_token': socialLogin.access_token,
                        'google_avatar': socialLogin.avatar_url,
                        'google_email_address': socialLogin.email_address,
                        'google_user_name': socialLogin.user_name,
                        'google_id': socialLogin.extra_fields['google_id']
                    });
                    this.initGoogleSourceSelectionPanel();
                    // Keen Tracking
                    if (!this.keenSelectedChannel) {
                        this.initKeenData();
                        this.keenData.channel = 'google';
                        App.execute('click:uploader', 'Selected channel', this.keenData);
                        this.keenSelectedChannel = true;
                    }
                }
            });
        },
        setReviewPanelEvents: function(reviewPanel) {
            this.listenTo(reviewPanel, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:product:search': function(photo, source) {
                    this.showProductSearchPanel(photo, source);
                },
                'show:submit:content': function() {
                    this.formView = this.getFormView({
                        model: Show.connectedUser,
                        collection: this.uploaderCollection,
                        source: this.source
                    });
                    this.setFormViewEvents(this.formView, this);
                    this.showFormView(this.formView, this);
                    // Keen Tracking
                    App.execute('click:uploader', 'Confirmed submission', this.keenData);
                },
                'show:confirm:panel': function(uploadCompleteData) {
                    this.confirmPanel = this.getConfirmPanel();
                    this.setConfirmPanelEvents(this.confirmPanel, this);
                    this.showConfirmPanel(this.confirmPanel, uploadCompleteData);
                },
                'show:select:content': function() {
                    if (!this.uploaderCollection.length) {
                        this.keenUploadedMedia = false;
                    }
                    this.layout.trigger('show:select:content');
                }
            });
        },
        setDragDropEvents: function(dragDropView) {
            this.listenTo(dragDropView, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:alert': function(alert, data) {
                    this.layout.onShowAlert(alert, data);
                },
                'reset:view': function() {
                    this.dragDropView.destroy();
                    if (!this.uploaderCollection.length) {
                        this.keenUploadedMedia = false;
                    }
                    this.uploaderCollection = new App.Entities.Collection();
                    this.dragDropView = this.getDragDropView({
                        collection: this.uploaderCollection,
                        connectedUser: Show.connectedUser
                    });
                    this.setDragDropEvents(this.dragDropView);
                    this.showDragDropView(this.dragDropView);
                },
                'show:review:panel': function(source) {
                    this.source = source;
                    this.initReviewPanel(source);
                },
                'show:confirm:panel': function(uploadCompleteData) {
                    this.confirmPanel = this.getConfirmPanel();
                    this.setConfirmPanelEvents(this.confirmPanel, this);
                    this.showConfirmPanel(this.confirmPanel, uploadCompleteData);
                }
            });
        },
        setFormViewEvents: function(formView) {
            this.listenTo(formView, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:confirm:panel': function(uploadCompleteData) {
                    this.confirmPanel = this.getConfirmPanel();
                    this.setConfirmPanelEvents(this.confirmPanel, this);
                    this.showConfirmPanel(this.confirmPanel, uploadCompleteData);
                },
                'show:failed:submission:panel': function() {
                    this.failedSubmissionPanel = new Show.FailedSubmissionPanel();
                    this.setFailedSubmissionPanelEvents(this.failedSubmissionPanel);
                    this.showFailedSubmissionPanel(this.failedSubmissionPanel);
                },
                'keen:completed:authorization': function(keenData) {
                    this.KeenData = _.extend(this.keenData, keenData);
                    App.execute('click:uploader', 'Completed authorization', this.keenData);
                }
            });
        },
        setFailedSubmissionPanelEvents: function(failedSubmissionPanel) {
            this.listenTo(failedSubmissionPanel, 'update:breadcrumb', function(step, backwards) {
                this.layout.onUpdateBreadcrumb(step, backwards);
            });
        },
        setInstagramSocialPhotoPanelEvents: function(socialPhotoPanel) {
            var _this = this;
            this.listenTo(socialPhotoPanel, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'show:review:panel': function(source) {
                    this.source = source;
                    this.initReviewPanel(source);
                },
                'load:more': function(params) {
                    var pagination = params.view.options.pagination;
                    pagination.page += 1;
                    $.ajax({
                        type: 'get',
                        url: pagination.nextUrl,
                        dataType: 'jsonp',
                        data: {
                            access_token: Show.connectedUser.get('instagram_token')
                        },
                        success: function(results) {
                            results.data.forEach(function(data) {
                                _this.images.push({
                                    picture: data.thumbnail_url || data.media_url,
                                    caption: data.caption || '',
                                    extra_data: JSON.stringify(data),
                                    type: data.media_type.toLowerCase(),
                                    id: data.id
                                });
                            });
                            if (results.paging && results.paging.cursors && results.paging.cursors.after) {
                                pagination.next = true;
                                pagination.nextUrl = `${url}?after=${results.paging.cursors.after}`;
                            } else {
                                pagination.next = false;
                                pagination.nextUrl = null;
                            }
                            _this.instagramPhotos.add(_this.images);
                            params.view.triggerMethod('loaded');
                        }
                    });
                }
            });
        },
        setFacebookSocialPhotoPanelEvents: function(socialPhotoPanel, options, type) {
            var _this = this;
            this.listenTo(socialPhotoPanel, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'show:album:view': function(view, options) {
                    this.showSocialPhotoAlbumsPanel(this.socialPhotoAlbumsPanel, this);
                },
                'show:review:panel': function(source) {
                    this.source = source;
                    this.initReviewPanel(source);
                },
                'load:more': function(params) {
                    var perPage = 25;
                    var pagination = params.view.options.pagination;
                    if (type === 'photo') {
                        FB.api('/' + options.model.get('id') + '/photos?fields=images,name,id,created_time&after=' + pagination.nextUrl, 'get', {
                            access_token: Show.connectedUser.get('facebook_token')
                        }, function(response) {
                            response.data.forEach(function(data) {
                                data.type = 'image';
                                data.picture = data.images[0].source;
                                data.caption = data.name || '';
                            });
                            if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.length >= perPage) {
                                pagination.next = true;
                                pagination.nextUrl = response.paging.cursors.after;
                            } else {
                                pagination.next = false;
                                pagination.nextUrl = null;
                            }
                            _this.photosCollection.add(response.data);
                            params.view.triggerMethod('loaded');
                        });
                    } else {
                        FB.api(pagination.nextUrl, 'get', {
                            access_token: Show.connectedUser.get('facebook_token')
                        }, function(response) {
                            response.data.forEach(function(data) {
                                data.type = 'video';
                            });
                            if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.length >= perPage) {
                                pagination.next = true;
                                pagination.nextUrl = response.paging.cursors.after;
                            } else {
                                pagination.next = false;
                                pagination.nextUrl = null;
                            }
                            _this.videoCollection.add(response.data);
                            params.view.triggerMethod('loaded');
                        });
                    }
                }
            });
        },
        setFacebookSocialPhotoAlbumsPanelEvents: function(socialPhotoAlbumsPanel) {
            var _this = this;
            this.listenTo(socialPhotoAlbumsPanel, {
                'get:focus:index': this.getFocusIndex.bind(this),
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'load:more': function(params) {
                    App.execute('get:facebook:albums', Show.connectedUser.get('facebook_token'), function(result, albumsPagination) {
                        _this.fbAlbumsCollection.add(result);
                        params.view.options.pagination = albumsPagination;
                        params.view.triggerMethod('loaded');
                    }, params.view.options.pagination.nextUrl);
                },
                'child:show:album:photos': function(view, options) {
                    FB.api('/' + options.model.get('id') + '/photos?fields=images,name,id,created_time', 'get', {
                        access_token: Show.connectedUser.get('facebook_token')
                    }, function(response) {
                        var perPage = 25;
                        var pagination = {
                            page: 1,
                            nextUrl: null,
                            next: false
                        };
                        response.data.forEach(function(data) {
                            data.type = 'image';
                            data.picture = data.images[0].source;
                            data.caption = data.name || '';
                        });
                        _this.photosCollection = new App.Entities.Collection(response.data);
                        if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.data.length >= perPage) {
                            pagination.next = true;
                            pagination.nextUrl = response.paging.cursors.after;
                        }
                        _this.source = 'facebook';
                        _this.socialPhotoPanel = _this.getSocialPhotoPanel({
                            collection: _this.photosCollection,
                            uploaderCollection: _this.uploaderCollection,
                            source: _this.source,
                            pagination: pagination
                        });
                        var type = 'photo';
                        _this.setFacebookSocialPhotoPanelEvents(_this.socialPhotoPanel, options, type);
                        _this.showSocialPhotoPanel(_this.socialPhotoPanel);
                    });
                },
                'child:show:album:videos': function(view, options) {
                    FB.api('me/videos?fields=description,picture,source', 'get', {
                        access_token: Show.connectedUser.get('facebook_token')
                    }, function(response) {
                        var perPage = 25;
                        var pagination = {
                            page: 1,
                            nextUrl: null,
                            next: false
                        };
                        if (_.isFalsy(response)) {
                            _this.videoCollection = new App.Entities.Collection();
                        } else {
                            response.data.forEach(function(data) {
                                data.type = 'video';
                                data.caption = data.description || '';
                            });
                            _this.videoCollection = new App.Entities.Collection(response.data);
                            if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.data.length >= perPage) {
                                pagination.next = true;
                                pagination.nextUrl = response.paging.next;
                            }
                        }
                        _this.source = 'facebook';
                        _this.socialPhotoPanel = _this.getSocialPhotoPanel({
                            collection: _this.videoCollection,
                            uploaderCollection: _this.uploaderCollection,
                            source: _this.source,
                            pagination: pagination
                        });
                        var type = 'video';
                        _this.setFacebookSocialPhotoPanelEvents(_this.socialPhotoPanel, options, type);
                        _this.showSocialPhotoPanel(_this.socialPhotoPanel);
                    });
                },
                'child:show:album:videos:uploaded': function(view, options) {
                    FB.api('me/videos?type=uploaded&fields=description,picture,source', 'get', {
                        access_token: Show.connectedUser.get('facebook_token')
                    }, function(response) {
                        var perPage = 25;
                        var pagination = {
                            page: 1,
                            nextUrl: null,
                            next: false
                        };
                        if (_.isFalsy(response)) {
                            _this.videoCollection = new App.Entities.Collection();
                        } else {
                            response.data.forEach(function(data) {
                                data.type = 'video';
                                data.caption = data.description || '';
                            });
                            _this.videoCollection = new App.Entities.Collection(response.data);
                            if (!_.isEmpty(response.paging) && !_.isEmpty(response.paging.cursors) && response.data.length >= perPage) {
                                pagination.next = true;
                                pagination.nextUrl = response.paging.next;
                            }
                        }
                        _this.source = 'facebook';
                        _this.socialPhotoPanel = _this.getSocialPhotoPanel({
                            collection: _this.videoCollection,
                            uploaderCollection: _this.uploaderCollection,
                            source: _this.source,
                            pagination: pagination
                        });
                        var type = 'video';
                        _this.setFacebookSocialPhotoPanelEvents(_this.socialPhotoPanel, options, type);
                        _this.showSocialPhotoPanel(_this.socialPhotoPanel);
                    });
                }
            });
        },
        setGooglePhotosPanelEvents: function(googlePhotosPanel) {
            this.listenTo(googlePhotosPanel, {
                'show:review:panel': function(source) {
                    this.source = source;
                    this.initReviewPanel(source);
                },
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'get:focus:index': this.getFocusIndex.bind(this),
                'show:google:source:selection': this.initGoogleSourceSelectionPanel,
                'show:google:photos': this.initGooglePhotosPanel,
                'show:google:albums': this.initGooglePhotosAlbumsPanel,
                'child:show:google:album:photos': this.initGooglePhotosPanel,
            }, this);
        },
        setConfirmPanelEvents: function(confirmPanel) {
            this.listenTo(confirmPanel, {
                'update:breadcrumb': this.updateBreadcrumb.bind(this),
                'get:focus:index': this.getFocusIndex.bind(this),
            });
        },
        setPreviewMode: function() {
            var _this = this;
            var formPanelTriggers;
            var homePanelTriggers;
            var confirmPanelTriggers;
            App.commands.setHandler('stylesheet:generated', function(css, params) {
                //setting temp variable
                var _formPanelTriggers = {
                    'dob_display': params.dob_display
                };
                var _homePanelTriggers = {
                    'uploader_homePanel_backgroundImage': params.uploader_homePanel_backgroundImage
                };
                var _confirmPanelTriggers = {
                    'thankYou_image_backgroundImage': params.thankYou_image_backgroundImage,
                    'thankYouUrl_input': params.thankYouUrl_input
                };
                //initialize general variables
                formPanelTriggers = formPanelTriggers || _formPanelTriggers;
                homePanelTriggers = homePanelTriggers || _homePanelTriggers;
                confirmPanelTriggers = confirmPanelTriggers || _confirmPanelTriggers;
                //check for new changes and trigger corespending screen
                if (!_.isEqual(_formPanelTriggers, formPanelTriggers)) {
                    formPanelTriggers = _formPanelTriggers;
                    _this.formView = _this.getFormView({
                        model: Show.connectedUser,
                        collection: _this.uploaderCollection,
                        source: _this.source
                    });
                    _this.setFormViewEvents(_this.formView);
                    _this.showFormView(_this.formView);
                } else if (!_.isEqual(_homePanelTriggers, homePanelTriggers)) {
                    homePanelTriggers = _homePanelTriggers;
                    _this.homeView = _this.getHomeView();
                    _this.setHomeViewEvents(_this.homeView);
                    _this.showHomeView(_this.homeView);
                } else if (!_.isEqual(_confirmPanelTriggers, confirmPanelTriggers)) {
                    App.displayOptions.set('thankYouUrl_input', params.thankYouUrl_input);
                    confirmPanelTriggers = _confirmPanelTriggers;
                    _this.confirmPanel = _this.getConfirmPanel();
                    _this.setConfirmPanelEvents(_this.confirmPanel);
                    _this.showConfirmPanel(_this.confirmPanel);
                }
            });
        },
        getLayout: function(options) {
            return new Show.Layout(options);
        },
        getHomeView: function(options) {
            return new Show.Home(options);
        },
        getReviewPanel: function(options) {
            return new Show.ReviewPanel(options);
        },
        getDragDropView: function(options) {
            return new Show.DragDrop(options);
        },
        getFormView: function(options) {
            return new Show.FormView(options);
        },
        getInfoView: function() {
            return new Show.InfoView();
        },
        getSocialPhotoPanel: function(options) {
            return new Show.SocialPhotoPanel(options);
        },
        getSocialPhotoAlbumsPanel: function(options) {
            return new Show.SocialPhotoAlbumPanel(options);
        },
        getConfirmPanel: function(options) {
            return new Show.ConfirmPanel(options);
        },
        getLoginView: function(options) {
            return new Show.LoginView(options);
        },
        getFocusIndex: function(element) {
            // if an element is not provided to this function, show the main content then get focus index
            if (_.isFalsy(element)) {
                this.layout.onShowMainContent();
            }
            this.layout.onGetFocusIndex(element);
        },
        updateBreadcrumb: function(step, backwards) {
            this.layout.onUpdateBreadcrumb(step, backwards);
        },
        showUploadHolderRegion: function(layoutView) {
            layoutView.onShowUploadHolder();
            layoutView.onHideMainContent();
        },
        showMainContentRegion: function(layoutView) {
            layoutView.onHideUploadHolder();
            layoutView.onShowMainContent();
        },
        showHomeView: function(homeView) {
            this.showMainContentRegion(this.layout);
            this.show(homeView, {
                region: this.layout.mainContent
            });
        },
        showLayout: function(layoutView) {
            this.show(layoutView, {
                loading: true
            });
        },
        showLoginView: function(loginView) {
            this.showMainContentRegion(this.layout);
            this.show(loginView, {
                region: this.layout.mainContent
            });
        },
        showReviewPanel: function(reviewPanel) {
            this.showMainContentRegion(this.layout);
            this.show(reviewPanel, {
                region: this.layout.mainContent
            });
        },
        showProductSearchPanel: function(photo, source) {
            this.showMainContentRegion(this.layout);
            var panel = new Show.ProductSearchPanel({
                model: photo,
                source: source
            });
            this.listenTo(panel, {
                'done:tagging': function(model) {
                    if (!photo.has('products')) {
                        photo.set('products', new Backbone.Collection());
                    }
                    photo.get('products').add(model);
                    this.initReviewPanel(source);
                },
                'show:review:panel': function(source) {
                    this.source = source;
                    this.initReviewPanel(source);
                }
            });
            this.show(panel, {
                region: this.layout.mainContent
            });
        },
        showDragDropView: function(dragDropView) {
            this.showUploadHolderRegion(this.layout);
            this.show(dragDropView, {
                region: this.layout.uploadHolder
            });
        },
        showSocialPhotoPanel: function(socialPhotoPanel) {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(socialPhotoPanel);
        },
        showSocialPhotoAlbumsPanel: function(socialPhotoAlbumsPanel) {
            //if the view is destroyed, then re-initialize it
            if (this.socialPhotoAlbumsPanel.isDestroyed) {
                this.socialPhotoAlbumsPanel = this.getSocialPhotoAlbumsPanel({
                    collection: this.fbAlbumsCollection,
                    pagination: this.albumsPagination
                });
                this.setFacebookSocialPhotoAlbumsPanelEvents(this.socialPhotoAlbumsPanel);
            }
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(this.socialPhotoAlbumsPanel);
        },
        showGooglePhotosPanel: function(googlePhotosPanel) {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(googlePhotosPanel);
        },
        showGooglePhotosAlbumsPanel: function() {
            //if the view is destroyed, then re-initialize it
            if (this.googlePhotosAlbumsPanel.isDestroyed) {
                this.googlePhotosAlbumsPanel = new Show.GooglePhotosAlbumPanel({
                    collection: this.googleAlbumsCollection,
                });
                this.setGooglePhotosPanelEvents(this.googlePhotosAlbumsPanel);
            }
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(this.googlePhotosAlbumsPanel);
        },
        showGoogleSourceSelectionPanel: function() {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(this.googleSourceSelectionPanel);
        },
        showFormView: function() {
            //if the view is destroyed, then re-initialize it
            if (this.formView.isDestroyed) {
                this.formView = this.getFormView({
                    model: Show.connectedUser,
                    collection: this.uploaderCollection,
                    source: this.source
                });
                this.setFormViewEvents(this.formView);
            }
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(this.formView);
        },
        showConfirmPanel: function(confirmPanel, uploadCompleteData) {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(confirmPanel);

            this.uploadCompleteEvent(uploadCompleteData);
        },
        showFailedSubmissionPanel: function(failedSubmissionPanel) {
            this.showMainContentRegion(this.layout);
            this.layout.mainContent.show(failedSubmissionPanel);
        },
        showInfoPanel: function(infoPanel) {
            // hide main content so it doesn't get focus indexed for keyboard users
            this.layout.onHideMainContent();
            this.layout.extraContent.show(infoPanel);
        },
        uploadCompleteEvent: function(uploadCompleteData) {
            var data = _.isObject(uploadCompleteData) ? uploadCompleteData : {};
            var obj = {
                name: 'pixlee:upload:complete',
                type: 'action',
                source: 'uploader',
                destination: 'parent',
                data: data
            };

            window.top.postMessage(JSON.stringify(obj), '*');
        },
        initKeenData: function() {
            // Initial Keen Data
            this.keenSelectedChannel = false;
            this.keenData = {
                header_options: this.options.display_options.headerOptions,
                widget_type: this.options.display_options.type
            };
        },
        initUploaderCollections: function() {
            this.images = [];
            this.keenUploadedMedia = false;
            this.uploaderCollection = new App.Entities.Collection();
            this.instagramPhotos = new App.Entities.Collection();
            this.photosCollection = new App.Entities.Collection();
            this.videoCollection = new App.Entities.Collection();
            this.fbAlbumsCollection = new App.Entities.Collection();
        },
        initFacebookSocialPhotoAlbumsPanel: function() {
            App.execute('get:facebook:albums', Show.connectedUser.get('facebook_token'), function(result, albumsPagination) {
                this.fbAlbumsCollection = new App.Entities.Collection(result);
                this.albumsPagination = albumsPagination;
                this.socialPhotoAlbumsPanel = this.getSocialPhotoAlbumsPanel({
                    collection: this.fbAlbumsCollection,
                    pagination: this.albumsPagination
                });
                this.setFacebookSocialPhotoAlbumsPanelEvents(this.socialPhotoAlbumsPanel);
                this.showSocialPhotoAlbumsPanel(this.socialPhotoAlbumsPanel);
            }.bind(this));
        },
        initGoogleSourceSelectionPanel: function() {
            this.googleSourceSelectionPanel = new Show.GoogleSourceSelectionPanel();
            this.setGooglePhotosPanelEvents(this.googleSourceSelectionPanel);
            this.showGoogleSourceSelectionPanel(this.googleSourceSelectionPanel);
        },
        initGooglePhotosAlbumsPanel: function() {
            this.googleAlbumsCollection = App.request('get:google:albums', Show.connectedUser.get('google_token'));
            this.googlePhotosAlbumsPanel = new Show.GooglePhotosAlbumPanel({
                collection: this.googleAlbumsCollection,
                uploaderCollection: this.uploaderCollection
            });
            this.initKeenData();
            this.keenData.channel = 'google_albums';
            App.execute('click:uploader', 'Select Secondary Source', this.keenData);
            this.setGooglePhotosPanelEvents(this.googlePhotosAlbumsPanel);
            this.showGooglePhotosAlbumsPanel(this.googlePhotosAlbumsPanel);
        },
        initGooglePhotosPanel: function(album) {
            /*
             * this function returns photos from a google library or album
             * by default it will return photos from a library
             * @param {album} is the album model that gets clicked
             */
            this.googlePhotosCollection = App.request('get:google:photos', Show.connectedUser.get('google_token'), album.model);
            this.googlePhotosPanel = new Show.GoogleLayout({
                collection: this.googlePhotosCollection,
                uploaderCollection: this.uploaderCollection,
                album: album.model
            });

            if (_.isFalsy(album.model)) {
                this.initKeenData();
                this.keenData.channel = 'google_library';
                App.execute('click:uploader', 'Select Secondary Source', this.keenData);
            }

            this.setGooglePhotosPanelEvents(this.googlePhotosPanel);
            this.showGooglePhotosPanel(this.googlePhotosPanel);
        },
        initInstagramSocialPhotoPanel: function() {
            var _this = this;
            const url = 'https://graph.instagram.com/' + Show.connectedUser.get('instagram_id') + '/media';
            $.ajax({
                type: 'get',
                url: url,
                dataType: 'jsonp',
                data: {
                    fields: 'caption,media_type,media_url,thumbnail_url,id,timestamp,permalink,username',
                    access_token: Show.connectedUser.get('instagram_token')
                },
                success: function(results) {
                    var pagination = {
                        page: 1,
                        nextUrl: null,
                        next: false
                    };

                    results.data.forEach(function(data) {
                        _this.images.push({
                            picture: data.thumbnail_url || data.media_url,
                            caption: data.caption || '',
                            extra_data: JSON.stringify(data),
                            type: data.media_type.toLowerCase(),
                            id: data.id
                        });
                    });
                    if (results.paging && results.paging.cursors && results.paging.cursors.after) {
                        pagination.next = true;
                        pagination.nextUrl = `${url}?after=${results.paging.cursors.after}`;
                    }
                    _this.instagramPhotos.add(_this.images);
                    _this.source = 'instagram';
                    _this.socialPhotoPanel = _this.getSocialPhotoPanel({
                        collection: _this.instagramPhotos,
                        uploaderCollection: _this.uploaderCollection,
                        source: _this.source,
                        pagination: pagination
                    });
                    _this.setInstagramSocialPhotoPanelEvents(_this.socialPhotoPanel);
                    _this.showSocialPhotoPanel(_this.socialPhotoPanel);
                },
                error: function(XMLHttpRequest, textStatus, errorThrown) {}
            });
        },
        initReviewPanel: function(source) {
            this.reviewPanel = this.getReviewPanel({
                collection: this.uploaderCollection,
                model: Show.connectedUser,
                source: source
            });
            this.setReviewPanelEvents(this.reviewPanel);
            this.showReviewPanel(this.reviewPanel, source);
            // Keen Tracking
            if (!this.keenUploadedMedia) {
                this.keenData = {
                    channel: source,
                    email: Show.connectedUser.get('email_address'),
                    name: Show.connectedUser.get('full_name'),
                    user_handle: Show.connectedUser.get('facebook_user_name') || Show.connectedUser.get('instagram_user_name'),
                    number_of_media: this.uploaderCollection.length
                };
                this.keenUploadMediaDebounce(this.keenData);
            }
        },
        keenUploadMedia: function(keenData) {
            this.keenUploadedMedia = true;
            App.execute('click:uploader', 'Uploaded media', keenData);
        },
        keenMapStep: function(step) {
            switch (step) {
                case 'one':
                    return 'Choose Source';
                case 'two':
                    return 'Select Content';
                case 'three':
                    return 'Review Submission';
                case 'four':
                    return 'Submit Content';
                default:
                    return '';
            }
        }
    });
});
